import React from 'react';

export default function SkeletonCard() {
  return (
    <div className="flex flex-col animate-pulse">
      <div className="aspect-[3/4] bg-smoke-lighter mb-5 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent -translate-x-full animate-[shimmer_2s_infinite]" />
      </div>
      <div className="h-6 bg-smoke-lighter w-3/4 mb-2" />
      <div className="h-4 bg-smoke-lighter w-1/2 mb-4" />
      <div className="h-3 bg-smoke-lighter w-full opacity-50" />
    </div>
  );
}